export const redondear = value =>
  Math.round((value + Number.EPSILON) * 100) / 100
